export default "/images/vendor/@coreui/icons/svg/flag/cif-tv.svg?a75a8efb9022fea4c1ea61b1d9deb792";